<template #default v-slot="{set}">
    <div>
        <ul class="tw-flex tw-flex-wrap tw-justify-center">
            <li v-for="({selected, participant:p}, index) in participants" :key="p.id">
                <div style="width: 360px; height: 340px" class="block tw-m-1">

                    <!-- <data-fetch 
                    :endpoint="'/api/participants/' + p.id" 
                    v-slot="{ items }"
                    :fetch-on-mount="true"> -->
                        <div class="block-title tw-px-2 tw-mb-0 tw-flex tw-justify-between">
                            <div class="tw-flex">
                                <input class="tw-m-4" 
                                type="checkbox" 
                                name="participants[]" 
                                v-model="participants[index].selected"
                                :value="p.id"
                                data-toggle="tooltip" 
                                data-placement="top" 
                                title="Is this contact complete and up-to-date?" 
                                :disabled="(primaryContactId == p.id) || (!p.npn && !p.noLicense) || !p.primary_address || !p.primary_phone || !p.primary_email" 
                                @change="runUpdate">

                                <h3>{{p.firstName}} {{p.lastName}}</h3>
                            </div>

                            <!-- if participant has complete information, add a green checkmark badge, otherwise note that we need more info -->
                            <div>
                                <div v-if="(p.npn || p.noLicense) && p.primary_address && p.primary_phone && p.primary_email" ></div>
                                <!-- <div v-if="(p.npn || p.noLicense) && p.primary_address && p.primary_phone && p.primary_email" class="badge tw-bg-lime-600 tw-mt-4">✓</div> -->
                                <div v-else class="badge tw-bg-pia-red tw-mt-4">Needs Info</div>
                            </div>
                        </div>

                        <table style="width: 100%; height: 100%" class="tw-mt-2">
                            <tbody>
                                <tr>
                                    <td style="vertical-align: top;" class="tw-pt-2">
                                        <div style="font-weight: bold">Id</div>
                                        {{p.id}}
                                    </td>
                                    <td style="vertical-align: top; width: 60%" class="tw-pt-2">
                                        <div style="font-weight: bold;">Primary Email</div>
                                        <div>{{p.primary_email ? p.primary_email.email : "?" }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: top;">
                                        <div style="font-weight: bold;">NPN</div>
                                        {{p.npn ? p.npn : (p.noLicense ? 'Not Licensed' : '?')}}
                                    </td>
                                    <td style="vertical-align: top;">
                                        <div style="font-weight: bold;">Primary Phone</div>
                                        <div v-if="p.primary_phone"> ({{p.primary_phone.area_code}}) {{p.primary_phone.digit_7_num.substring(0,3)}}-{{p.primary_phone.digit_7_num.substring(3,7)}} <span v-if="p.primary_phone.ext"> ext. {{p.primary_phone.ext}}</span></div>                                        <div v-else>?</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: top;"> 
                                        <div style="font-weight: bold;">Part-time</div>
                                        <div v-if="!Object.keys(p).length == 0 && p.companies.find(item => item.id == companyId).pivot.parttime">Yes</div>
                                        <div v-else>No</div>
                                    </td>
                                    <td style="vertical-align: top;">
                                        <div style="font-weight: bold;">Primary Address</div>
                                        <div v-if="p.primary_address">
                                            <div>{{p.primary_address.line1}}<br></div>
                                            <div v-if="p.primary_address.line2">{{p.primary_address.line2 }}<br></div>
                                            <div>
                                                {{p.primary_address.city}},
                                                {{p.primary_address.state}}
                                                {{p.primary_address.zip_code}}
                                            </div>
                                        </div>
                                        <div v-else>?</div>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- $magazineKeycode = ($p->hasKeycode('Act II - NE') || $p->hasKeycode('Act ll - Mag & Mailing') )? 'checked="checked"' : '';
                                    $mailingKeycode = ($p->hasKeycode('Act ll - Mailing Only') || $p->hasKeycode('Act ll - Mag & Mailing') )? 'checked="checked"' : -->
                                    <td colspan="2" style="vertical-align: top;">
                                        <div class="tw-flex tw-justify-between">
                                            <div style="width: 75%">
                                                <div>
                                                    <input 
                                                    type="checkbox" 
                                                    name="magazine[]" 
                                                    :value="p.id"
                                                    :checked="(p.hasMagAndMailingKeycode || p.hasMagazineKeycode)"
                                                    :disabled="(!p.npn && !p.noLicense) || !p.primary_address || !p.primary_phone || !p.primary_email">
                                                    Yes, I want the PIA Magazine
                                                </div>

                                                <div>
                                                    <input 
                                                    type="checkbox" 
                                                    name="mailing[]" 
                                                    :value="p.id"
                                                    :checked="(p.hasMagAndMailingKeycode || p.hasMailingKeycode)"
                                                    :disabled="(!p.npn && !p.noLicense) || !p.primary_address || !p.primary_phone || !p.primary_email">
                                                    Yes, I want the PIA Monthly Mailing on Upcoming Events
                                                </div>
                                            </div>
                                            <div class="tw-justify-end">
                                                <button type="button" class="btn btn-default tw-m-2 " @click="editContact(p)" data-toggle="tooltip" data-placement="top" title="Edit">
                                                    <i class="fa fa-pencil-square-o "></i>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    <!-- </data-fetch> -->
                </div>
            </li>
            <li>
                <div style="width: 360px; height: 340px" class="block tw-m-1">
                    <div class="block-title tw-px-2 tw-mb-0 tw-flex tw-justify-between"> 
                        <h3>New Contact</h3>
                    </div>
                    
                    <button type="button" @click="createContact" class="btn btn-default tw-mx-2 tw-my-4" data-toggle="tooltip" data-placement="top" title="Create">
                        + Create Contact
                    </button>
                    
                </div>
            </li>
        </ul>
        <!-- <input name="filteredParticipants[]" :value="filteredParticipants"> -->
        <!-- <input type="text" hidden="hidden" readonly="readonly" name="countFTEs" :value="countFTEs"> -->
    </div>
</template>
<script>
import DataFetch from './DataFetch.vue';
export default {
    name: "ContactCards",
    props: {
        renew: {
            type: Boolean,
            default: true,
        },
        companyId: {
            type: Number,
            required: true,
        },
        primaryContactId: {
            
        },
        membershipId: {
            type: Number,
            required: false,
        }
    },
    data() {
        return {
            participants: [],
            magazine: [],
            mailing: [],
            uri: '/api/participants?paginate=false&withContactInfo=true&companyId=' + this.companyId,
            membershipUri: this.membershipId ? '/api/membership/' + this.membershipId + '/currentContactIds' : "",
        }
    },
    computed:{
        filteredParticipants(){
            let f = this.participants.filter(p => (p.selected == true) || (p.participant.id == this.primaryContactId));
            
            return f; //this.participants.filter(p => (p.selected == true) || (p.id == this.primaryContactId));
        },
        countFTEs(){
            let count = 0;
            this.filteredParticipants.forEach(p => {
                let participant = p.participant;
                let parttime = participant.companies.find(item => item.id == this.companyId).pivot.parttime;
                if(!participant.npn){
                    // don't count if no npn
                }else if(parttime){
                    count = count + 0.5;
                }else{
                    count++;
                }
            });
            count = Math.floor(count);
            if(count < 1){
                count = 1;
            }
            
            console.log('participant count: ' + count);
            return count;
        },
        
    },
    watch:{
        primaryContactId:{
            handler(newVal) {
                let item = this.participants.find(item => item.participant.id == newVal);
                item.selected = true;
            }
        }
    },
    mounted(){
        /* from data-fetch code */

        this.$nextTick(() => {
            this.get();
        });
        EventBus.$on('added-participant', this.addedParticipant);
        EventBus.$on('updated-participant', this.refreshParticipant);
    },
    methods: {
        /* from DataFetch code */
            get() {
                
                this.loading = true;
                this.$nextTick(() => {
                    axios.get(this.uri)
                    .then(response => {
                        this.$emit('update', response.data);
                        this.loading = false;
                        if(this.membershipId){
                            
                            this.$nextTick(() => {
                                axios.get(this.membershipUri)
                                .then(mResponse => {
                                    response.data.forEach(p => {
                                        
                                        this.participants.push({
                                            selected: mResponse.data.includes(p.id),
                                            participant: p,
                                        });
                                    });
                                    this.$nextTick(() => {
                                        this.$emit('participant-num', this.countFTEs);
                                    });
                                });
                            });
                        }else{
                            response.data.forEach(p => {
                                let preselectParticipant = (p.id == this.primaryContactId || ((p.npn || p.noLicense) && p.primary_address && p.primary_phone && p.primary_email)) ? true : false;
                                
                                this.participants.push({
                                    selected: preselectParticipant,
                                    participant: p,
                                });  
                            });
                            this.$nextTick(() => {
                                this.$emit('participant-num', this.countFTEs);
                            });
                        }
                        
                        this.$nextTick(() => {
                            
                            //this.$emit('filtered-participants', this.filteredParticipants.id);
                            this.$emit('participants-update', this.filteredParticipants);
                        });
                    });
                });
            },
        runUpdate(event){
            console.log('ran update');
            this.$emit('participant-num', this.countFTEs);
            this.$emit('participants-update', this.filteredParticipants);
        },
        createContact(){
            this.$emit('create-contact');
        },
        addedParticipant(p){
            this.$nextTick(() => {
                console.log('added-participant' + p.id);
                p = p.id;
                
                this.participants.push({
                    selected: true,
                    participant: p,
                    
                    
                }); 
                
                this.$emit('participant-num', this.countFTEs);
                this.$emit('participants-update', this.filteredParticipants);
            });
        },
        refreshParticipant(participantId){
            console.log('refreshParticipant' + participantId);
            //let hasParticipant = participantId ?? false;
            if(!participantId){
                console.log('no participantId yet');
                return;
            }
            let uri = "/api/participants/" + participantId;
        
            this.$nextTick(() => {
                        axios.get(uri)
                        .then(response => {
                            console.log('data-fetch contact card', response.data);
                            this.loading = false;
                            let item = this.participants.find(x => x.participant.id == response.data.id);
                            
                            item.selected = true;
                            item.participant = response.data;
                            console.log(item.participant);
                            this.$emit('participant-num', this.countFTEs);
                        });
                    });     
        },
        editContact(participant){
            this.$emit('edit-contact', participant);
        },
    }
}
</script>
<style >
</style>